import { useEffect, useState } from "react";

const LAUNCH = new Date("2026-10-01T00:00:00+07:00").getTime();

export const Countdown = () => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, LAUNCH - now);
  const units = [
    ["HARI", Math.floor(diff / 86400000)],
    ["JAM", Math.floor(diff / 3600000) % 24],
    ["MENIT", Math.floor(diff / 60000) % 60],
    ["DETIK", Math.floor(diff / 1000) % 60],
  ];

  return (
    <div data-testid="launch-countdown" className="flex items-stretch gap-2 sm:gap-3">
      {units.map(([label, val], i) => (
        <div key={label} className="flex items-center gap-2 sm:gap-3">
          <div className="border border-white/15 bg-ink-surface/80 px-3 py-2.5 text-center sm:px-4 sm:py-3">
            <div className="font-mono text-xl font-bold tabular-nums text-buy sm:text-2xl">
              {String(val).padStart(2, "0")}
            </div>
            <div className="mt-0.5 font-mono text-[9px] tracking-[0.25em] text-mute-dim">{label}</div>
          </div>
          {i < units.length - 1 && <span className="font-mono text-mute-dim">:</span>}
        </div>
      ))}
    </div>
  );
};
